import React from "react";
import "../../Components/Menu/Menu.css";

export default function Permission() {
  return (
    <div>
      <h4 className="sub-title">Tillatelse til tilganger på telefonen </h4>
      <p className="content">
        Du vil bli bedt om å gi Bilista tilgangstillatelser på telefonen. Det er
        frivillig for deg å gi slike tilganger, men dersom du avslår eller
        deaktiverer tilgangsforespørsler, vil dette føre til at funksjonaliteten
        i Bilista-appen reduseres.
        <ul>
          <li>
            {" "}
            Tillate pushvarsler: For å gi deg varsler som minner deg på bestilte
            tjenester og avtaler, varsel om ny faktura, nye funksjonaliteter i
            appen, skifte til vinterdekk osv.{" "}
          </li>
          <li>
            Tilgang til lokasjonsdata: For å kunne gi deg tilgang til data der
            du er; for å bruke bomkalkulatoren og for å finne tjenester og
            tilbydere i nærheten av der du er.
          </li>
        </ul>
        Du kan når som helst velge å skru av disse tilgangene inne på
        «Innstillinger» på telefonen din.
      </p>
    </div>
  );
}
